(ns minorodata.recipes.model
  (:require [mold.core :as m :include-macros true]
            [minorodata.users.model :refer [searchable-user]]))

(m/defmodel recipe
  {:recipe-id    [::m/string ::m/identity "ID"]

   :name         [::m/string ::m/nilable "Recipe name"]
   :description  [::m/string ::m/nilable "Description"]

   :enabled      [::m/bool "Enabled flag"]

   :image        [::m/string ::m/nilable "Logo image URL"]

   :updated-at   [::m/string "Created at ISO timestamp"]
   :created-at   [::m/string "Created at ISO timestamp"]

   :version      [::m/string ::m/nilable "Template version number"]

   :templates    [::m/map "Templates definition"]})
